import './LoadingComponent.scss';
import { FC, useContext } from 'react';
import LoadingComponentProps from './LoadingComponentProps';


const LoadingComponent: FC<LoadingComponentProps> = ({ showLogo = false, fullScreen = false }) => {
  return <div className={`loading_component ${fullScreen && 'full_screen'}`}>
    {showLogo && <img className='logo' src='/assets/logo_white.png' alt='logo' />}
    <div className='loading' />
    <strong>Cargando...</strong>
  </div>

}

export default LoadingComponent;
